import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function create(data) {
  const response = await http
    .postData("/spri", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// async function riwayat(nomor: string, tgl_awal, tgl_akhir) {
//   const response = await http
//     .getData(`/spri?nokartu=${nomor}&tgl_awal=${tgl_awal}&tgl_akhir=${tgl_akhir}`)
//     .catch(err => {
//       ErrorAlert.showErrorAlert(err);
//       return Promise.reject(err);
//     });

//   return response.data;
// }

async function hapus(data) {
  const response = await http
    .deleteData("/spri", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function edit(data) {
  const response = await http
    .putData("/spri", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(noSrk) {
  window.open(`${http.getAPI()}/spri/${noSrk}/cetak`, "_blank");
}

export default {
  create,
  // riwayat,
  hapus,
  print,
  edit
};
